import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import MultiSelectNoRef from 'components/common/MultiSelectNoRef';

const BaseDropdownV2 = ({
  fieldName,
  handleChange,
  isMulti = true,
  placeholder = '',
  value,
  collapseValues = false,
  closeMenuOnSelect = false,
  disabled = false,
  maxToShow = 4,
  getSource,
  sourceParam,
  mapToOption,
  styles,
  required = false,
  showError = false,
  hasError
}) => {
  const [options, setOptions] = useState([]);
  const isMounted = useRef(null);

  const handleValue = value => {
    if (typeof value === 'number') {
      return options?.find(x => x.value === value);
    } else if (typeof value === 'string') {
      const arr = value.split(',');
      return options?.filter(x => arr?.some(i => i.toString() == x.value));
    } else if (Array.isArray(value) && value.length > 0) {
      return options?.filter(x => value?.some(i => i.toString() == x.value));
    }
    return value;
  };

  useEffect(() => {
    isMounted.current = true;
    const controller = new AbortController();

    getSource(sourceParam ? sourceParam : controller.signal)
      .then(res => {
        if (!isMounted.current) return;
        if (res) setOptions(mapToOption(res));
      })
      .catch(err => console.log('Error in user fetch', err));

    return () => {
      isMounted.current = false;
      controller.abort();
    };
  }, []);
  const isInvalid =
    showError &&
    required &&
    ((typeof hasError === 'function' && hasError()) ||
      !value ||
      (Array.isArray(value) && value.length === 0));

  return (
    <div className="w-100">
      <MultiSelectNoRef
        disabled={disabled}
        closeMenuOnSelect={closeMenuOnSelect}
        isMulti={isMulti}
        options={options}
        placeholder={placeholder}
        collapseValues={collapseValues}
        maxToShow={maxToShow}
        onChange={selectedOptions => handleChange(fieldName, selectedOptions)}
        value={handleValue(value)}
        menuPortalTarget={document.body}
        styles={{
          ...styles,
          control: (base, state) => ({
            ...base,
            borderColor: isInvalid
              ? 'red !important'
              : state.isFocused
              ? '#2684FF'
              : base.borderColor,
            boxShadow: 'none',
            '&:hover': {
              borderColor: state.isFocused ? '#2684FF' : base.borderColor
            }
          }),
          menuPortal: base => ({ ...base, zIndex: 9999 })
        }}
      />
      {/* {isInvalid && showError && (
        <div className="text-danger small mt-1">Please select a value</div>
      )} */}
    </div>
  );
};

BaseDropdownV2.propTypes = {
  selectedOptions: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  handleChange: PropTypes.func,
  isMulti: PropTypes.bool,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array
  ]),
  collapseValues: PropTypes.bool,
  maxToShow: PropTypes.number,
  closeMenuOnSelect: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  showError: PropTypes.bool,
  getSource: PropTypes.func,
  hasError: PropTypes.func,
  sourceParam: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  mapToOption: PropTypes.func,
  styles: PropTypes.object
};

export default BaseDropdownV2;
